export const isWorkspaceMemberTier = (
  tier: string | null | undefined,
): boolean => {
  const normalized = String(tier || "")
    .trim()
    .toLowerCase();
  return normalized === "collaborator" || normalized === "company_member";
};

export const isBrandMemberTier = (
  tier: string | null | undefined,
): boolean =>
  String(tier || "")
    .trim()
    .toLowerCase() === "collaborator";

export const getWorkspaceMemberLabel = (
  tier: string | null | undefined,
): "Brand Member" | "Company Member" | null => {
  const normalized = String(tier || "")
    .trim()
    .toLowerCase();
  if (normalized === "collaborator") {
    return "Brand Member";
  }
  if (normalized === "company_member") {
    return "Company Member";
  }
  return null;
};
